export const COMPARECACHEACTIONS = {
  COMPARECACHE_PUSHDATA: 'comparecache/pushdata',
  COMPARECACHE_PUSHPENDING: 'comparecache/pushpending',
} as const;
